import React from 'react';
import { getNodeSearchLabel } from '../../utils/mindmap/nodeSearch';

const FocusNavigation = ({
  path,
  isDarkMode,
  canGoBack,
  canGoForward,
  onBack,
  onForward,
  onNavigate,
  topOffset = 16,
}) => {
  // Focus history may remain available after returning to the full map, but
  // the branch navigation belongs only to an actively focused branch.
  if (!path.length) return null;
  const foreground = isDarkMode ? '#f7f7f8' : '#171719';
  const surface = isDarkMode ? 'rgba(39, 39, 42, 0.9)' : 'rgba(255, 255, 255, 0.92)';
  const button = {
    border: 0, background: 'transparent', color: foreground, cursor: 'pointer',
    maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  };

  return (
    <nav
      aria-label="Focused branch navigation"
      data-export-ignore="true"
      data-viewport-occlusion="true"
      onMouseDown={(event) => event.stopPropagation()}
      style={{
        position: 'absolute', top: topOffset, left: '50%', transform: 'translateX(-50%)',
        zIndex: 140, display: 'flex', alignItems: 'center', gap: 4, maxWidth: 'calc(100vw - 120px)',
        padding: '7px 10px', color: foreground, background: surface, borderRadius: 10,
        boxShadow: '0 5px 22px rgba(0,0,0,0.18)', overflow: 'hidden',
      }}
    >
      <button type="button" onClick={onBack} disabled={!canGoBack} aria-label="Previous focused view" style={{ ...button, opacity: canGoBack ? 1 : 0.35 }}>‹</button>
      <button type="button" onClick={onForward} disabled={!canGoForward} aria-label="Next focused view" style={{ ...button, opacity: canGoForward ? 1 : 0.35 }}>›</button>
      <span aria-hidden="true" style={{ opacity: 0.4 }}>|</span>
      {path.map((node, index) => (
        <React.Fragment key={node.id}>
          {index > 0 && <span aria-hidden="true" style={{ opacity: 0.45 }}>›</span>}
          <button
            type="button"
            onClick={() => onNavigate(index === 0 ? null : node.id)}
            title={getNodeSearchLabel(node)}
            style={{ ...button, fontWeight: index === path.length - 1 ? 700 : 400 }}
          >
            {getNodeSearchLabel(node)}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default FocusNavigation;
